import { h, FunctionalComponent, createRef } from "preact";
import styled from "styled-components";
import { useContext, useState } from 'preact/hooks';

import { SwiperSlide } from 'swiper/react'
import { Carousel } from "../../components/Carousel";
import { DelYeahContainer } from "../../containers/DelYeahContainer";
import { MapIcon } from "../../icons/Map";
import { CloseIcon } from "../../icons/Close";

import { WhatsNewOffer, Reward } from "@authentic/loyalty-pwa/interfaces";
import { OfferServiceContext } from "@authentic/loyalty-pwa/providers";
import { useEffect } from "react";
import { RewardsPointsWidget, TierWidgetType } from "../../components/tier-widget/RewardsPointsWidget";
import { Link } from "preact-router";
import { useUser } from "@authentic/loyalty-pwa/providers";
import { Snackbar, SnackbarType } from "../../components/snackbar/snackbar";
import { link, route } from "@authentic/loyalty-pwa/util";
import { breakpoints } from "@authentic/loyalty-pwa/util/variables";

const RewardsSlideContent = styled.div<{ padding: boolean }>`
  padding: ${p => (p.padding ? "18px 0" : "")};
  background-color: white;
  text-align: center;
  height: 408px;
  .cta-user-tier {
    margin-top: 44px;
  }
`;

const CallToActionButton = styled.div`
  font-weight: 800;
  background-color: black;
  color: white;
  text-transform: uppercase;
  font-size: 14px;
  display: inline-block;
  padding: 12px 24px;
  margin-top: 24px;
  cursor: pointer;
  min-width: 164px;
`;


const FeaturedRewardStyled = styled.div`
  .top-title, .subtitle {
    font-size: 14px;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    padding: 0 24px;
  }

  .top-title {
    border-bottom: 2px solid #95B040;
  }
`;

const FeaturedRewardImageStyled = styled.div<{ imageSrc: string }>`
  background-image: url(${(p) => p.imageSrc});
  background-repeat: no-repeat;
  background-position: bottom center;
  width: 100px;
  height: 100px;
  display: block;
  margin: 24px auto;
  background-size: cover;
`;

const WhatsNewSlideContent = styled.div`
  padding: 0 0 24px 0;
  background-color: white;
  text-align: center;
  height: 408px;

  img {
    width: 100%;
    height: 173px;
  }

  span, p {
    padding: 0 12px;
  }

  span {
    font-size: 18px;
    font-weight: 700;
    margin-top: 20px;
    display: block;
    height: 42px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 0;
    height: 52px;
    margin-top: 12px;
  }
`;

const WhatsNewImageStyled = styled.div<{ imageSrc: string }>`
  background-image: url(${(p) => p.imageSrc});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 192px;
  display: block;
`;

const FavoriteLocationStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 678px;
  margin: 0 auto;
  svg, .favorite-location-description, .favorite-location-buttons {
    flex-grow: 1;
    width: 33%;
  }

  svg {
    width: auto;
  }

  .favorite-location-description, .favorite-location-buttons {
    padding: 0 10px;
  }

  .favorite-location-description {
    span {
      display: block;
      padding: 4px 0;
      font-size: 16px;
    }

    span:nth-child(1) {
      font-weight: 700;
      font-size: 18px;
    }
  }

  .favorite-location-buttons {
    > div {
      width: 100%;
      text-align: center;
    }

    > div:nth-child(1) {
      margin-top: 0;
    }

    > div:nth-child(2) {
      background: white;
      color: black;
      border: 1px solid black;
      margin-top: 16px;
    }
  }

  @media screen and (max-width: ${breakpoints.md}) {
    width: 100%;
  }

  @media screen and (max-width: 678px) {//custom breakpoint
    display: block;

    svg, .favorite-location-description, .favorite-location-buttons {
      width: 100%;
      text-align: center;
    }

    .favorite-location-description {
      margin: 12px 0 24px;
    }
  }
  
`;

const LayoutStyled = styled.div`
  font-family: 'Nunito Sans';
  max-width: 1127px;
  margin: 0 auto;
  padding: 32px 0;
  letter-spacing: 0.01em;
  overflow-x: hidden;
  h2 {
    font-weight: normal;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 800;
    text-align: center;
    margin: 0;
    margin-bottom: 8px;
  }
`;

const PrevFooterStyled = styled.div`
  background: white;
  padding: 48px 24px;
`;

const ModalStyled = styled.div`
  z-index: 3000;
  position: fixed;
  display: table;
  height:100%;
  width:100%;
  top: 0;
  left: 0;
  transform:scale(0);
  @keyframes fadeIn {
    0% {
      background:rgba(0,0,0,.0);
    }
    100% {
      background:rgba(0,0,0,.8);
    }
  }

  @keyframes fadeOut {
    0% {
      background:rgba(0,0,0,.8);
    }
    100% {
      background:rgba(0,0,0,.0);
    }
  }

  @keyframes scaleUp {
    0% {
      transform:scale(.8) translateY(1000px);
      opacity:0;
    }
    100% {
      transform:scale(1) translateY(0px);
      opacity:1;
    }
  }

  @keyframes scaleDown {
    0% {
      transform:scale(1) translateY(0px);
      opacity:1;
    }
    100% {
      transform:scale(.8) translateY(1000px);
      opacity:0;
    }
  }

  &.revealing {
    transform:scale(1);
    .modal-overlay {
      background-color: rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }

    .modal-content {
      opacity:0;
      animation: scaleUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }

    &.out {
      animation: quickScaleDown 0s .5s linear forwards;
      .modal-overlay {
        animation: fadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
      .modal-content {
        animation: scaleDown .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
     }
    }
  }
`;

const FAQButtons = styled.div`
  border-top: 1px solid #9D9D9D;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  margin-bottom: -30px;
`

const ModalContentStyled = styled.div`
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 341px;
  max-width: 100%;
  min-height: 150px;
  padding: 0;
  overflow: initial;
  display: block;
  margin-left: -170.5px;
  margin-top: -237.5px;

  .modal-close-button {
    cursor: pointer;
    svg {
      position: absolute;
      top: -28px;
      right: 0;
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  @media screen and (max-width: ${breakpoints.xss} ) {
    width: 320px;
    margin-left: -160px;
  }
`;

const ModalOverlayStyled = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  display:table-cell;
`;

const FooterLink = styled.a`
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
 
`

const OfferDetailStyled = styled.div`
  text-align: center;
  font-family: 'Nunito Sans';
  padding-bottom: 32px;
  img {
    width: 183px;
  }
  .title {
    font-weight: 700;
    font-size: 18px;
    display: block;
    padding: 24px;
  }
  .subtitle {
    font-size: 12px;
    letter-spacing: 0.03em;
    padding: 0 12px;
  }

  p {
    font-weight: 400;
    margin-bottom: 12px;
    margin-top: 12px;
  }
  .link-button {
    margin: 12px 0 0;
    cursor: pointer;
  }
`;

interface CarouselItem {
  id: number,
  heading: string,
  subheading: string,
  image_url: string,
  thumbnail_url: string,
  original_image_url: string,
  target_url: string,
  internal_url: string,
  action: string,
  description: string,
  url: string,
  type: string,
  page?: string,
}

interface DelYeahRewardItem {
  title: string,
  imageUrl: string
}

let whatsNewOffers: CarouselItem[] = [];
let delYeahRewards: DelYeahRewardItem[] = [];

export const DelYeahHomePage: FunctionalComponent = () => {
  const ref = createRef();
  const user = useUser();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState(SnackbarType.Success);

  const offersService = useContext(OfferServiceContext);
  const [offerIndexSelected, setOfferIndexSelected] = useState(-1);
  const [isModalActive, setIsModalActive] = useState(false);

  const [offerList, setOfferList] = useState<CarouselItem[]>(whatsNewOffers);
  const [delYeahRewardList, setDelYeahRewardList] = useState<DelYeahRewardItem[]>(delYeahRewards);
  const htmlTitle: string = 'Del Yeah! Rewards';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '1';
  const getFeaturedRewardsErrorMessage: string = 'There was an error to get featured rewards.';

  const openOfferDetail = (id: number, e: any) => {
    setOfferIndexSelected(whatsNewOffers.findIndex((item) => item.id === id));
    setIsModalActive(true);
  };

  const hideModal = () => {
    setIsModalActive(false);
    setOfferIndexSelected(-1);
  };

  const modalToggle = (e: any) => {
    if (isModalActive) {
      hideModal();
    } else {
      setIsModalActive(true);
    }
  };

  useEffect(() => {
    whatsNewOffers = [];
    offersService?.getWhatsNewOffers({
      placement: 'mobile_carousel'
    }).then((res: any) => {
      if (res.success) {
        res.offers.map((offer: WhatsNewOffer) => {
          whatsNewOffers.push({
            id: offer.id,
            heading: offer.heading,
            subheading: offer.subheading,
            image_url: offer.image_url,
            thumbnail_url: offer.thumbnail_url,
            original_image_url: offer.original_image_url,
            target_url: offer.target_url,
            internal_url: offer.internal_url,
            action: offer.action,
            description: offer.description,
            url: offer.url,
            type: offer.type,
            page: offer.extra_json?.page
          })
        });
        setOfferList(whatsNewOffers);
      }
    });
  }, []);

  useEffect(() => {
    if (user.summary) {
      getRewardsDelYeah();
    }
  }, [user]);

  const getRewardsDelYeah = () => {
    delYeahRewards = [];
    let tierName = '';
    if (user && user.tier_data) {
      tierName = user.tier_data.current_tier_name
    }

    if (user.rewards?.success && user.rewards?.rewards) {
      user.rewards?.rewards
        .filter((reward: Reward) => reward.categories.indexOf(tierName) > -1)
        .map((reward: Reward) => {
          console.log('o' + reward.image_url)
          delYeahRewards.push({
            title: reward.title,
            imageUrl: reward.image_url,
          })
          setDelYeahRewardList(delYeahRewards);
        });
    } else {
      setSnackbarMessage(user.rewards?.error?.message || getFeaturedRewardsErrorMessage);
      setSnackbarType(SnackbarType.Error);
      setOpenSnackbar(true);
    }

  };

  const orderNow = (findLocation: boolean) => {
    if (findLocation) {
      window.open('https://locations.deltaco.com/search', '_blank');
    } else {
      window.open(link('/order'), '_blank');
    }
  };

  const callbackOnCloseSnackbar = () => {
    setOpenSnackbar(false);
    console.log('callbackOnCloseSnackbar...');
  };

  const callToActionItemSlide = (page: string) => {
    switch (page) {
      case 'rewards':
        route('/your-rewards')
        break;
      case 'scan':
        route('/scan-code')
        break;
      default:
        route('/your-rewards')
        break
    }
  }

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <LayoutStyled>

        <h2>What's new</h2>

        {offerList.length > 0 && (
          <Carousel indexCarouselRef={2} spaceBetween={20}>
            <SwiperSlide>
              <RewardsSlideContent padding={true}>
                <RewardsPointsWidget type={TierWidgetType.BASIC} />

                <Link href={link('/your-rewards')}>
                  <CallToActionButton className='cta-user-tier'>
                    View Rewards
                  </CallToActionButton>
                </Link>
              </RewardsSlideContent>
            </SwiperSlide>
            {offerList?.map((item: CarouselItem) => (
              <SwiperSlide>
                <WhatsNewSlideContent >
                  <div onClick={openOfferDetail.bind(this, item.id)}>
                    <WhatsNewImageStyled imageSrc={item.image_url}></WhatsNewImageStyled>
                    <span dangerouslySetInnerHTML={{ __html: item.heading }}></span>
                    {item.subheading && <p class="subtitle" dangerouslySetInnerHTML={{ __html: item.subheading }}></p>}
                    {!item.subheading && item.description && <p class="subtitle" dangerouslySetInnerHTML={{ __html: item.description }}></p>}
                  </div>
                  {(item.type && item.type === 'url' && !item.page) &&
                    <CallToActionButton onClick={() => window.open(item.url, '_blank')} >
                      {item.action}
                    </CallToActionButton>
                  }

{/*
                  {(item.type && item.type === 'stellar' && !item.page) &&
                    <CallToActionButton onClick={() => console.log('redirect to "refer a friend" page... WIP')} >
                      {item.action}
                    </CallToActionButton>
                  }
*/}
                  {(!item.type && item.page) &&
                    <CallToActionButton onClick={() => callToActionItemSlide(item.page || '') } >
                      {item.action}
                    </CallToActionButton>
                  }
                </WhatsNewSlideContent>
              </SwiperSlide>
            ))}
          </Carousel>
        )}
      </LayoutStyled>

      {isModalActive && offerIndexSelected > -1 && (
        <ModalStyled className={(isModalActive ? 'revealing' : 'revealing out')}>
          <ModalContentStyled className="modal-content">

            <OfferDetailStyled>
              <span class="modal-close-button" onClick={modalToggle}><CloseIcon></CloseIcon></span>

              <WhatsNewImageStyled imageSrc={offerList[offerIndexSelected].image_url}></WhatsNewImageStyled>

              <span class="title" dangerouslySetInnerHTML={{ __html: offerList[offerIndexSelected].heading }}></span>
              <p class="subtitle" dangerouslySetInnerHTML={{ __html: offerList[offerIndexSelected].subheading }}></p>
              {offerList[offerIndexSelected].description && <p class="subtitle" dangerouslySetInnerHTML={{ __html: offerList[offerIndexSelected].description }}></p>}
              {(offerList[offerIndexSelected].type && offerList[offerIndexSelected].type === 'url') &&
                <CallToActionButton className="link-button" onClick={() => window.open(offerList[offerIndexSelected].url, '_blank')}  >
                  {offerList[offerIndexSelected].action}
                </CallToActionButton>
              }
{/*
              {(offerList[offerIndexSelected].type && offerList[offerIndexSelected].type === 'stellar' && !offerList[offerIndexSelected].page) &&
                <CallToActionButton className="link-button" onClick={() => console.log('redirect to "refer a friend" page... WIP')}  >
                  {offerList[offerIndexSelected].action}
                </CallToActionButton>
              }
*/}
              {(!offerList[offerIndexSelected].type && offerList[offerIndexSelected].page) &&
                <CallToActionButton className="link-button" onClick={() => callToActionItemSlide(offerList[offerIndexSelected].page || '') }  >
                  {offerList[offerIndexSelected].action}
                </CallToActionButton>
              }

            </OfferDetailStyled>
          </ModalContentStyled>
          <ModalOverlayStyled className="modal-overlay"></ModalOverlayStyled>
        </ModalStyled>
      )}

      {user && user.favorite_location && (
        <PrevFooterStyled>
          <FavoriteLocationStyled>
            <MapIcon></MapIcon>
            <div class="favorite-location-description">
              <span>My Favorite Location</span>
              <span>{user.favorite_location.address}</span>
              <span>{user.favorite_location.city}, {user.favorite_location.state} {user.favorite_location.zip_code}</span>
            </div>

            <div class="favorite-location-buttons">
              <CallToActionButton onClick={orderNow.bind(this, false)}>
                Order now
              </CallToActionButton>

              <CallToActionButton onClick={orderNow.bind(this, true)}>
                Find Another Location
              </CallToActionButton>
            </div>

          </FavoriteLocationStyled>
        </PrevFooterStyled>
      )}
      <FAQButtons>
        <FooterLink href={link('/about')}>About the Program</FooterLink>
      </FAQButtons>
      <Snackbar
        message={snackbarMessage}
        isActive={openSnackbar}
        type={snackbarType}
        timeout={6000}
        callbackOnClose={callbackOnCloseSnackbar}></Snackbar>
    </DelYeahContainer>
  )
}
